import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Logout = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4C12 4.55228 11.5523 5 11 5H5L5 19H11C11.5523 19 12 19.4477 12 20C12 20.5523 11.5523 21 11 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H11C11.5523 3 12 3.44772 12 4Z"
        fill={color}
      />
      <path
        d="M15.0001 15.5858L17.5858 13.0001H9.00005C8.44776 13.0001 8.00005 12.5524 8.00005 12.0001C8.00005 11.4478 8.44777 11.0001 9.00005 11.0001L17.5858 11.0001L15 8.41428C14.6095 8.02375 14.6095 7.39059 15 7.00006C15.3905 6.60954 16.0237 6.60954 16.4142 7.00006L20.7072 11.293C20.8947 11.4805 21 11.7349 21 12.0001C21 12.2653 20.8947 12.5197 20.7072 12.7072L16.4143 17.0001C16.0238 17.3906 15.3906 17.3906 15.0001 17.0001C14.6096 16.6095 14.6096 15.9764 15.0001 15.5858Z"
        fill={color}
      />
    </svg>
  );
});

export default Logout;
